import React from "react";
import { useQuery } from "react-query";
import { ErrorMessage, Field, Form, Formik } from "formik";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { BorderWrapper, ButtonWithIcon, Container } from "../../lib";
import { getFinisedMatches } from "../../../../api/match/matchApi";
import FanReportSpecialPerMatchTable from "./FanReportSpecialTable";

const  FanReportSpecialPerMatch= () => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const pageFromQuery = searchParams.get("page");
  const page = pageFromQuery ? parseInt(pageFromQuery) : 1;
  const [queryString, setQueryString] = React.useState<{
    page: number | string;
    search: string;
    filter: string | number;
    numberInPage: number | string;
    timeFrame: string;
  }>({
    page,
    search: "",
    filter: "",
    numberInPage: 5,
    timeFrame: "all",
  });
  const location = useLocation();
  const { state, pathname } = location as any;

  const initialData = state?.data || undefined;
  const { data, isLoading, isError, error, refetch } = useQuery(
    [
      "finisedMatchesList",
      queryString.page,
      queryString.numberInPage,
      queryString.search,
      queryString.timeFrame,
    ],
    () => getFinisedMatches({ ...queryString })
  );

  //handlers
  const setQSandEnable = (values) => {
    // setEnableQ(()=>true)
    setQueryString(values);
    refetch();
  };
  const setQS = (page) => {
    //@ts-ignore
    setSearchParams({ page });
    setQueryString((state) => ({
      ...state,
      page: page,
    }));
  };

  if (isLoading) return <div>Loading...</div>;
  if (isError) return <div>Error: </div>;

  return (
    <Container className={"bg-white p-0 mt-10"}>
      {/*Header Start*/}
      <div
        className={
          "d-flex align-items-center justify-content-between table-header"
        }
      >
        <BorderWrapper className={"gap-4"}>
          <div className={"d-flex flex-column"}>
            <span className={"title-m-c"}>آمار فروش</span>
            <span>
              <span className={"me-1"}>{data?.totalRows}</span>بازی
            </span>
          </div>
        </BorderWrapper>

    
      </div>

      {/*Table Start*/}
      {/*@ts-ignore*/}
      {data?.matches.length ? (
        <FanReportSpecialPerMatchTable
          queryString={queryString}
          setQueryString={setQS}
          data={data}
          refetch={refetch}
          numberInPage={Number(queryString.numberInPage)}
        />
      ) : (
        <p className={"p-2 m-2"}>فیلدی با این خصوصیات پیدا نشد. </p>
      )}
    </Container>
  );
};



export default FanReportSpecialPerMatch;
